var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChoice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_6591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.99963 5.29504C3.99963 4.30933 4.80164 3.50732 5.78748 3.50732C6.77319 3.50732 7.57532 4.30933 7.57532 5.29504V6.73584C8.0719 6.58398 8.43433 6.12146 8.43433 5.57568V2.08887C8.43433 1.42004 7.89014 0.875977 7.22131 0.875977H4.35364C3.68481 0.875977 3.14062 1.42004 3.14062 2.08887V5.57568C3.14062 6.12146 3.50293 6.58398 3.99963 6.73584V5.29504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1666 0.875977H10.2988C9.63 0.875977 9.08594 1.42004 9.08594 2.08887V5.57568C9.08594 6.24451 9.63 6.78857 10.2988 6.78857H13.1666C13.8354 6.78857 14.3796 6.24451 14.3796 5.57568V2.08887C14.3796 1.42004 13.8354 0.875977 13.1666 0.875977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9441 8.41162C10.4694 8.41162 10.0847 8.79639 10.0847 9.271V8.83325C10.0847 8.35864 9.69997 7.97388 9.22524 7.97388C8.75063 7.97388 8.36587 8.35852 8.36587 8.83325V8.46509C8.36587 8.01367 8.01784 7.64392 7.57558 7.60864C7.55275 7.60693 7.52981 7.60571 7.50649 7.60571C7.16005 7.60571 6.86171 7.81091 6.72573 8.1062C6.67544 8.21545 6.64712 8.33691 6.64712 8.46509V5.29492C6.64712 4.82031 6.26235 4.43555 5.78774 4.43555C5.31313 4.43555 4.92837 4.82031 4.92837 5.29492V12.6729L4.89113 12.6681L4.36172 10.402C4.25368 9.93982 3.7914 9.65259 3.32924 9.76062C2.84389 9.76062 2.53713 10.1473 2.64748 10.62L3.26137 13.2473C3.58242 15.303 5.24416 16.8759 5.24416 16.8759H10.4654C11.3378 15.549 11.8028 13.9957 11.803 12.4076L11.8035 9.271C11.8035 8.79639 11.4187 8.41162 10.9441 8.41162Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_6591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.5 0.875977)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChoice);
export default __webpack_public_path__ + "static/media/choice.09bd8508357402488ede50fd4f304f80.svg";
export { ForwardRef as ReactComponent };